import { Button, IconButton, SxProps, Tooltip } from '@mui/material';
import { CopyIcon } from '../../icons/CopyIcon';
import { ReactNode, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function CopyButton({
  value,
  variant = 'icon',
  children,
  buttonSx,
  iconSx,
}: {
  value: string;
  variant?: 'icon' | 'text';
  children?: ReactNode;
  buttonSx?: SxProps;
  iconSx?: SxProps;
}) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const handleClick = useCallback(() => {
    if (typeof navigator !== 'undefined' && navigator?.clipboard?.writeText) {
      navigator?.clipboard
        ?.writeText(value)
        .then(() => true)
        .catch(() => false)
        .then((nextCopied) => setCopied(nextCopied));
    }
  }, [value]);

  useEffect(() => {
    if (copied) {
      const id = setTimeout(() => setCopied(false), 1000);
      return () => clearTimeout(id);
    }
  }, [copied]);

  return (
    <Tooltip title={copied ? t('Copied') : t('Copy')}>
      {variant === 'icon' ? (
        <IconButton onClick={handleClick} color="info" sx={buttonSx}>
          <CopyIcon sx={iconSx} />
        </IconButton>
      ) : (
        <Button onClick={handleClick} color="info" variant="text">
          {children}
        </Button>
      )}
    </Tooltip>
  );
}
